import styled from 'styled-components'

export const Required = styled.span`
  color: red;
  margin-left: 0.5rem;
`

export const FieldDescriptionsH4 = styled.h4`
  display: inline-block;
`



// WEBPACK FOOTER //
// ./src/components/Pacing/styles.js